import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/Layout.js";
import Image from '../components/Image';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`GraphQL es una arquitectura de diseño de APIs y tiene una sintaxis particular
para describir cómo consultar data que tiene 3 características principales:`}</p>
    <ul>
      <li parentName="ul">{`Permite al cliente especificar exactamente qué data necesita (con sintaxis
`}<em parentName="li">{`parecida`}</em>{` a un objeto JSON)`}</li>
      <li parentName="ul">{`Facilita traer data de fuentes múltiples`}</li>
      <li parentName="ul">{`Usa un sistema de tipos para describir la data`}</li>
    </ul>
    <p>{`Hasta ahora todo muy de manual, pero sigamos así se entiende un poco más todo 😊`}</p>
    <h3>{`REST vs GraphQL`}</h3>
    <p>{`Veamos las diferencias que tienen GraphQL vs una API REST:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`API REST`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`GraphQL`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Múltiples endpoints`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Un solo endpoint`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Puede producirse over/under fetching (pedir data de menos/más)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Se pide sólo la data necesaria`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Puede retrasar tiempos de desarrollo si el endpoint no está preparado`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Es más dinámico en preparación de datos desde el back`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Es explícito el tipo de petición que se realiza`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No es tan claro el tipo de petición`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Más claro para manejo de request params / variables`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Quizás un poco menos claro para manejo de variables`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Debe mantenerse la documentación al día`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Es autodocumentado`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Distintas versiones pueden romper compatibilidad`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Es incremental, disminuye la incompatibilidad entre versiones`}</td>
        </tr>
      </tbody>
    </table>
    <p><em parentName="p">{`Tengan en claro que algunas cosas de esta tabla son opiniones personales, si
alguien cree que las cosas no son como las digo y me puede explicar, soy todo
oídos`}</em>{` 🤗`}</p>
    <p>{`Veamos una comparación de cómo debería traerse la data desde una API REST contra
una GraphQL si estuviésemos haciendo, por ejemplo, una red social:`}</p>
    <h4>{`REST`}</h4>
    <h2><Image imgName="rest.png" alt="Peticiones a una API REST" mdxType="Image" /></h2>
    <h4>{`GraphQL`}</h4>
    <h2><Image imgName="graphql.png" alt="Peticiones a una API GraphQL" mdxType="Image" /></h2>
    <p>{`Como vemos, según como está armada esta API REST, para mostrar la data de lo que
sería el `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Home`}</code>{` de algo similar a la red social del pajarito, tendríamos que
hacer 3 peticiones para traer los datos que, utilizando GraphQL, podríamos traer
en una sola petición. Ahí se nota la diferencia en cantidad de endpoints.`}</p>
    <p>{`Todo esto que digo no es que quiera decir que GraphQL es `}<em parentName="p">{`mejor`}</em>{` o que `}<em parentName="p">{`viene a
reemplazar a REST`}</em>{`, sino que nació con la idea de mejorar algunas falencias de
REST, pero REST es mejor en otras cosas y situaciones. (cosa que no vamos a
cubrir acá porque sino se hace larguísimo jajajaja 😅)`}</p>
    <p>{`En nuestro caso, nosotros vamos a ver cómo se piden datos para utilizarlos en el
frontend, podemos encontrar un ejemplo de una `}<strong parentName="p">{`query`}</strong>{` (consulta) en el archivo
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`src/components/layout.js`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` data `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useStaticQuery`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`graphql`}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p><strong parentName="p">{`Qué #$%#$ es esto, Agustin?`}</strong>{` 😒 Sí, yo sé que al principio dije que era
`}<em parentName="p">{`parecida`}</em>{` a JSON la sintaxis y esto tiene cosas que nada que ver. Por suerte,
como Gatsby es re copado ya viene con una herramienta fantástica para ver toda
la data que tenemos disponible para consultar mediante GraphQL. Si notaron en la
consola luego de correr el comando `}<strong parentName="p">{`gatsby develop`}</strong>{`, dice que si van a
http://localhost:8000/`}<em parentName="p">{`__graphql se van a encontrar con `}<strong parentName="em">{`GraphiQL`}</strong>{` donde vamos
a ver listado del lado izquierdo en la sección _Explorer`}</em>{` toda la data que
tenemos disponible para traernos al frontend con GraphQL.`}</p>
    <Image imgName="graphiql.png" alt="Interfaz de graphiql" mdxType="Image" />
    <p>{`En la imagen vemos que a la izquierda nos va a aparecer toooooodo lo que tenemos
disponible, no va a ser exactamente igual que en la imagen pero podemos ver
cosas como `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`allFile`}</code>{` para consultar todos los archivos que exponemos con el
plugin `}<strong parentName="p">{`gatsby-source-filesystem`}</strong>{` que nos vino preinstalado, también `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`file`}</code>{`
para consultar por cierto archivo usando filtros, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`allImageSharp`}</code>{` para todas las
fotos, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`imageSharp`}</code>{` para una sola foto, y así... Se entiende la diferencia? 😉`}</p>
    <p>{`Entonces si vemos nuestra query y el resultado de realizarla en el lado derecho
de `}<strong parentName="p">{`GraphiQL`}</strong>{`, vemos que nos traemos el título de nuestra página, pero dónde
definimos nosotros eso? 🤔 Esto viene predefinido con Gatsby, y son valores que
están en el archivo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-config.js`}</code>{`, donde veremos este objeto:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`siteMetadata`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    title`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`Gatsby Default Starter`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    description`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`Kick off your next, great Gatsby project with this default starter. This barebones starter ships with the main Gatsby configuration files you might need.`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    author`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`@gatsbyjs`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span></code></pre></div>
    <p>{`El cual va a tener toda la metadata de nuestro proyecto, así que esos tres
valores (title, description y author) van a ser consultables tranquilamente en
cualquier lugar de nuestro frontend si los requerimos! (prueben en GraphiQL si
no me creen 😛) Creo que mas que seguir explicando cosas, van a aprender más si
empiezan a jugar un poco con GraphiQL.`}</p>
    <p>{`Nuestros proyectos de github todavía no los tenemos disponibles para consultar y
usar en el frontend, para eso necesitamos generar la query en la configuración
del plugin y ya estaría (recuerden que nuestros archivos `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-algo.js`}</code>{`
funcionan como nuestro backend), vamos al siguiente paso para verlo 😁`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      